import React, { useEffect } from 'react'
import { translate } from 'react-i18next'
import ym from 'react-yandex-metrika'
import { Helmet } from 'react-helmet'
import './style.css'

import AS_RU from '../../../assets/images/as_ru.png'
import PM_RU from '../../../assets/images/pm_ru.png'

import Logo from './assets/logo.png'

import Intro_1280w from './assets/intro-1280w.jpg'
import Intro_768w from './assets/intro-768w.jpg'
import Intro_480w from './assets/intro-480w.jpg'

import Mockup_1280w from './assets/mockup-1280w.png'
import Mockup_768w from './assets/mockup-768w.png'
import Mockup_480w from './assets/mockup-480w.png'

import Group_1280w from './assets/group-1280w.png'
import Group_768w from './assets/group-768w.png'
import Group_480w from './assets/group-480w.png'
import Feedback from '../../../Feedback'

const Tommy = ({ t }) => {

    useEffect(() => {
        document.body.classList.add('tommy')
        ym('hit', '/our-works/tommy')
        return () => {
            document.body.classList.remove('tommy')
        }
    })

    return (
        <div className="app__content--project">
            <Helmet>
                <title>{ t('tommy.name') }</title>
            </Helmet>
            <main className="content__ds">
                <div className="content__ds--intro mt-4">
                    <div className="content__ds--logo-container">
                        <img src={ Logo } alt={ t('tommy.name') } className="content__ds--logo" />
                    </div>
                    <div className="content__ds--text">
                        <p className="content__ds--p">{ t('tommy.text1') }</p>
                    </div>
                </div>

                <div className="content__logos">
                    <a
                        href="https://apps.apple.com/ru/app/tommy-house/id1465362981"
                        target="_blank"
                        rel="nofollow noreferrer noopener">
                        <img src={ AS_RU } alt="AppStore Tommy House" className="content__logos__logo" />
                    </a>
                    <a
                        href="https://play.google.com/store/apps/details?id=one.clockwork.tommy&hl=ru"
                        target="_blank"
                        rel="nofollow noreferrer noopener">
                        <img src={ PM_RU } alt="Play Market Tommy House" className="content__logos__logo" />
                    </a>
                </div>

                <div className="content__ds--fluid">
                    <img
                        srcSet={ `
                ${ Intro_480w } 480w,
                ${ Intro_768w } 768w,
                ${ Intro_1280w } 1280w` }
                        sizes="100vw"
                        src={ Intro_480w }
                        alt="Tommy House"
                        className="content__ds--image" />
                </div>

                <div className="content__ds--issue">
                    <div>
                        <h2 className="content__ds--h2">{ t('issue') }</h2>
                    </div>
                    <div className="content__ds--text">
                        <p className="content__ds--p">{ t('tommy.issue') }</p>
                    </div>
                </div>

                <div className="content__ds--fluid">
                    <img
                        srcSet={ `
                ${ Mockup_480w } 480w,
                ${ Mockup_768w } 768w,
                ${ Mockup_1280w } 1280w` }
                        sizes="100vw"
                        src={ Mockup_480w }
                        alt="Tommy House"
                        className="content__ds--image" />
                </div>

                <div className="content__ds--solve">
                    <div>
                        <h2 className="content__ds--h2">{ t('solve') }</h2>
                    </div>
                    <div className="content__ds--text">
                        <p className="content__ds--p">{ t('tommy.solve1') }</p>
                        <p className="content__ds--p">{ t('tommy.solve2') }</p>
                    </div>
                </div>

                <div className="content__ds--fluid">
                    <img
                        srcSet={ `
                ${ Group_480w } 480w,
                ${ Group_768w } 768w,
                ${ Group_1280w } 1280w` }
                        sizes="100vw"
                        src={ Group_480w }
                        alt="Tommy House"
                        className="content__ds--image" />
                </div>

                <div className="m-5 ma">
                    <div className="content__logos">
                        <a
                            href="https://apps.apple.com/ru/app/tommy-house/id1465362981"
                            target="_blank"
                            rel="nofollow noreferrer noopener">
                            <img src={ AS_RU } alt="AppStore Tommy House" className="content__logos__logo" />
                        </a>
                        <a
                            href="https://play.google.com/store/apps/details?id=one.clockwork.tommy&hl=ru"
                            target="_blank"
                            rel="nofollow noreferrer noopener">
                            <img src={ PM_RU } alt="Play Market Tommy House" className="content__logos__logo" />
                        </a>
                    </div>
                </div>

                <section className="m-5 ma">
                    <Feedback />
                </section>

            </main>
        </div>
    )
}


export default translate('translations')(Tommy)



// WEBPACK FOOTER //
// ./src/Pages/Projects/Tommy/index.js